module.exports = __webpack_public_path__ + "fonts/Inter-Bold.ec64ea5.woff2";